import { ViteReactSSG } from 'vite-react-ssg'
import { routes, getStaticPaths } from './routes'
import App from './App.tsx'
import './styles/globals.css'
import { 
  preloadCriticalResources, 
  initPerformanceMonitoring, 
  registerServiceWorker,
  inlineCriticalCSS 
} from './utils/performanceOptimizer'

// Create SSG-enabled app
export const createRoot = ViteReactSSG(
  // React Router data routes for pre-rendering
  { routes },
  
  // Custom setup function that runs on both client and server
  ({ router, routes: routeConfig, isClient, initialState }) => {
    
    // Global error handlers for debugging (client-side only)
    if (isClient) {
      window.addEventListener('error', (event) => {
        console.error('Global error:', event.error)
        console.error('Error details:', {
          message: event.message,
          filename: event.filename,
          lineno: event.lineno,
          colno: event.colno
        })
      })

      window.addEventListener('unhandledrejection', (event) => {
        console.error('Unhandled promise rejection:', event.reason)
      })

      // Initialize performance optimizations AFTER error handlers
      try {
        preloadCriticalResources()
        inlineCriticalCSS()
      } catch (error) {
        console.error('Performance optimizer error:', error)
      }

      // Initialize performance monitoring in development
      if (process.env.NODE_ENV === 'development') {
        try {
          initPerformanceMonitoring()
        } catch (error) {
          console.error('Performance monitoring error:', error)
        }
      }

      // Register service worker for production
      if (process.env.NODE_ENV === 'production') {
        registerServiceWorker().catch(error => {
          console.error('Service worker registration error:', error)
        })
      }

      console.log('🚀 SSG-enabled React app initialized', {
        isClient,
        initialState: !!initialState,
        routes: routeConfig?.length || 0,
        deployment_target: import.meta.env.VITE_DEPLOYMENT_TARGET
      })
    }
    
    return <App />
  }
)

// Export static paths for build-time generation
export { getStaticPaths }